import { Component, OnInit, output, input } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';
import { JkBaseComponent } from '../jkbase/jkbase.component';

export type Format = 'billions' | 'currency' | 'day' | 'decimal' | 'exponential' | 'fixedPoint' | 'largeNumber' | 'longDate' | 'longTime' | 'millions' | 'millisecond' | 'month' | 'monthAndDay' | 'monthAndYear' | 'percent' | 'quarter' | 'quarterAndYear' | 'shortDate' | 'shortTime' | 'thousands' | 'trillions' | 'year' | 'dayOfWeek' | 'hour' | 'longDateLongTime' | 'minute' | 'second' | 'shortDateShortTime';

let parent : JksliderComponent ;

@Component({
  selector: 'app-jkslider',
  templateUrl: './jkslider.component.html',
  styleUrls: ['./jkslider.component.scss'],
  standalone: true,
  imports: [MatLabel]
})
export class JksliderComponent extends JkBaseComponent  implements OnInit {
  override comType: string = 'jkslider';
  readonly min = input<number>(0);
  readonly max = input<number>(100);
  readonly minText = input<string>('');
  readonly maxText = input<string>('');
  // width default for slider
  readonly value = input<number | undefined>(0);
  readonly valueChange = output<number>();
  onValueChange(newValue: number) {
    this.valueChange.emit(newValue);
  }
  readonly step = input<number>(1);

  constructor() {
    super();
    this.width.set(300);
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  format(value:string):Format | string | undefined { // Format | undefined
    return `${value}`; // 改callback
  }
}
